(() => {
  // src/lib/upsell-debug.ts
  var isUpsellDebug = () => {
    var _a;
    if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) return true;
    try {
      return new URLSearchParams(window.location.search).get("rebuy_debug") === "1";
    } catch (e) {
      return false;
    }
  };

  // src/lib/selling-plan-utils.ts
  var parsePlanMap = (jsonText) => {
    if (!jsonText) return {};
    try {
      const parsed = JSON.parse(jsonText);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  };
  var getVariantPlans = (map, variantId) => map[String(variantId)];
  var hasPlans = (variantPlans) => !!variantPlans && variantPlans.plans.length > 0;
  var UNIT_RANK = { day: 0, week: 1, month: 2, year: 3 };
  var planSortKey = (label) => {
    var _a;
    const lower = label.toLowerCase();
    const match = lower.match(/(\d+)?\s*(day|week|month|year)/);
    if (!match) return Number.MAX_SAFE_INTEGER;
    const count = match[1] ? parseInt(match[1], 10) : 1;
    const unit = (_a = UNIT_RANK[match[2]]) != null ? _a : 3;
    return unit * 1e3 + count;
  };
  var sortPlansByFrequency = (plans) => [...plans].sort((a, b) => planSortKey(a.label) - planSortKey(b.label));
  var bestDiscountPlan = (plans) => plans.reduce(
    (best, p) => !best || p.discount > best.discount ? p : best,
    void 0
  );
  var isPrepaidPlan = (plan) => /prepaid/i.test((plan == null ? void 0 : plan.label) || "");
  var preferredPlan = (sortedPlans) => sortedPlans.find((p) => !isPrepaidPlan(p)) || sortedPlans[0];
  var findPlanById = (plans, id) => id == null ? void 0 : plans.find((p) => String(p.id) === String(id));

  // src/purchase-panel-core.ts
  (() => {
    window.HotelCollection = window.HotelCollection || {};
    if (window.HotelCollection.PurchasePanelCore) return;
    window.HotelCollection.PurchasePanelCore = /* @__PURE__ */ (() => {
      const formatMoney = (cents) => "$" + (cents / 100).toFixed(2);
      const attrInt = (el, attr) => parseInt(el.getAttribute(attr), 10) || 0;
      const getDiscountedPrice = (baseCents, pct) => pct > 0 ? Math.round(baseCents * (1 - pct / 100)) : baseCents;
      const makeAnimateBtnContent = (btnInner, prefix) => (updateFn, reverse = false) => {
        if (!btnInner) {
          updateFn();
          return;
        }
        const outClass = reverse ? `${prefix}-label--out-reverse` : `${prefix}-label--out`;
        const inClass = reverse ? `${prefix}-label--in-reverse` : `${prefix}-label--in`;
        const clone = btnInner.cloneNode(true);
        clone.style.cssText = "position:absolute;inset:0;display:inline-flex;align-items:center;justify-content:center;gap:inherit;pointer-events:none;";
        btnInner.parentElement.appendChild(clone);
        void clone.offsetHeight;
        clone.classList.add(outClass);
        updateFn();
        void btnInner.offsetHeight;
        btnInner.classList.add(inClass);
        clone.addEventListener("animationend", () => clone.remove(), {
          once: true
        });
        btnInner.addEventListener(
          "animationend",
          () => btnInner.classList.remove(inClass),
          { once: true }
        );
      };
      const makeAnimateImageTransition = (variantImage, prefix) => {
        let animSeq = 0;
        const dataAttr = `${prefix}In`;
        const selector = `img[data-${prefix}-in]`;
        return (newSrc, newAlt, goRight) => {
          if (!variantImage) return;
          const col = variantImage.parentElement;
          const seq = ++animSeq;
          col.querySelectorAll(selector).forEach((el) => el.remove());
          variantImage.classList.remove(
            `${prefix}-img--out-left`,
            `${prefix}-img--out-right`
          );
          const dir = goRight ? {
            out: `${prefix}-img--out-left`,
            in: `${prefix}-img--in-right`,
            pre: `${prefix}-img--pre-right`
          } : {
            out: `${prefix}-img--out-right`,
            in: `${prefix}-img--in-left`,
            pre: `${prefix}-img--pre-left`
          };
          const inClone = document.createElement("img");
          inClone.src = newSrc;
          inClone.alt = newAlt;
          inClone.dataset[dataAttr] = "";
          inClone.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:contain;pointer-events:none;";
          inClone.classList.add(dir.pre);
          col.appendChild(inClone);
          void inClone.offsetHeight;
          variantImage.classList.add(dir.out);
          inClone.classList.add(dir.in);
          inClone.addEventListener(
            "animationend",
            () => {
              if (seq !== animSeq) return;
              variantImage.src = newSrc;
              variantImage.alt = newAlt;
              const revealReal = () => {
                if (seq !== animSeq) {
                  inClone.remove();
                  return;
                }
                variantImage.classList.remove(dir.out);
                inClone.remove();
              };
              if (variantImage.complete && variantImage.naturalWidth > 0) {
                revealReal();
              } else {
                variantImage.addEventListener("load", revealReal, { once: true });
                variantImage.addEventListener("error", revealReal, {
                  once: true
                });
              }
            },
            { once: true }
          );
        };
      };
      const initSubscribeToggle = (section, {
        submitBtn,
        btnInner,
        btnLabel,
        btnPriceEl,
        btnBadge,
        sellingPlanInput,
        purchaseToggle,
        togglePill,
        subscribeDetails,
        subscribeClass,
        addToCartClass,
        toggleBtnActiveClass,
        pillRightClass,
        collapsibleHiddenClass,
        animPrefix
      }) => {
        if (!purchaseToggle) return;
        const animateBtnContent = makeAnimateBtnContent(btnInner, animPrefix);
        purchaseToggle.addEventListener("click", (e) => {
          const btn = e.target.closest("[data-toggle]");
          if (!btn) return;
          if (btn.classList.contains(toggleBtnActiveClass)) return;
          const isSubscribe = btn.getAttribute("data-toggle") === "subscribe";
          purchaseToggle.querySelectorAll("[data-toggle]").forEach((b) => {
            const active = b === btn;
            b.classList.toggle(toggleBtnActiveClass, active);
            b.setAttribute("aria-pressed", String(active));
          });
          togglePill == null ? void 0 : togglePill.classList.toggle(pillRightClass, !isSubscribe);
          subscribeDetails == null ? void 0 : subscribeDetails.classList.toggle(
            collapsibleHiddenClass,
            !isSubscribe
          );
          if (sellingPlanInput) {
            sellingPlanInput.value = isSubscribe ? sellingPlanInput.dataset.sellingPlanId || "" : "";
          }
          if (submitBtn) {
            const baseCents = attrInt(submitBtn, "data-base-price");
            const discountPct = attrInt(submitBtn, "data-subscribe-discount");
            const subscribeCents = attrInt(submitBtn, "data-subscribe-price") || getDiscountedPrice(baseCents, discountPct);
            const templateMode = submitBtn.dataset.atcTemplateMode === "true";
            submitBtn.classList.toggle(subscribeClass, isSubscribe);
            submitBtn.classList.toggle(addToCartClass, !isSubscribe);
            animateBtnContent(() => {
              if (templateMode) return;
              if (btnLabel)
                btnLabel.textContent = isSubscribe ? "Subscribe \u2014" : (submitBtn.dataset.atcLabel ? submitBtn.dataset.atcLabel + " \u2014" : "Add to Cart \u2014");
              if (btnPriceEl)
                btnPriceEl.textContent = formatMoney(
                  isSubscribe ? subscribeCents : baseCents
                );
              if (btnBadge) {
                if (isSubscribe && discountPct > 0) {
                  btnBadge.textContent = discountPct + "% off";
                  btnBadge.removeAttribute("hidden");
                } else {
                  btnBadge.textContent = "";
                  btnBadge.setAttribute("hidden", "");
                }
              }
            }, isSubscribe);
          }
        });
      };
      const initQuantityChange = (section, {
        submitBtn,
        btnPriceEl,
        subscribeClass,
        qtyInput
      }) => {
        const updatePrice = (qty) => {
          if (!submitBtn || !btnPriceEl) return;
          const baseCents = attrInt(submitBtn, "data-base-price");
          const isSubscribeMode = submitBtn.classList.contains(subscribeClass);
          const unitCents = isSubscribeMode ? attrInt(submitBtn, "data-subscribe-price") || getDiscountedPrice(
            baseCents,
            attrInt(submitBtn, "data-subscribe-discount")
          ) : baseCents;
          btnPriceEl.textContent = formatMoney(unitCents * qty);
        };
        section.addEventListener(
          "quantity:change",
          (e) => {
            var _a, _b;
            return updatePrice(
              (_b = (_a = e.detail) == null ? void 0 : _a.quantity) != null ? _b : 1
            );
          }
        );
        if (qtyInput)
          qtyInput.addEventListener(
            "change",
            () => updatePrice(Math.max(1, parseInt(qtyInput.value, 10) || 1))
          );
      };
      const initVariantPlanSync = (section, {
        sellingPlanInput,
        variantIdInput,
        submitBtn,
        btnPriceEl,
        btnBadge,
        purchaseToggle,
        frequencyWrap,
        subscribeClass,
        managePrice = true
      }) => {
        const plansEl = section.querySelector("[data-subscription-plans]");
        if (!plansEl || !sellingPlanInput) return;
        const log = (...args) => {
          if (isUpsellDebug()) console.log("[subscription]", ...args);
        };
        const planMap = parsePlanMap(plansEl.textContent);
        const frequencyDropdown = (frequencyWrap == null ? void 0 : frequencyWrap.querySelector("dropdown-component")) || null;
        const frequencyHidden = (frequencyDropdown == null ? void 0 : frequencyDropdown.querySelector(
          'input[type="hidden"]'
        )) || null;
        let selectedPlanId = sellingPlanInput.dataset.sellingPlanId || "";
        const currentVariantId = () => (variantIdInput == null ? void 0 : variantIdInput.value) || "";
        const isSubscribe = () => !!(submitBtn == null ? void 0 : submitBtn.classList.contains(subscribeClass));
        const setDropdownSelection = (planId) => {
          if (!frequencyDropdown) return;
          const options = Array.from(
            frequencyDropdown.querySelectorAll(".dropdown__option")
          );
          const opt = options.find((o) => o.dataset.value === planId);
          if (!opt) return;
          if (frequencyHidden) frequencyHidden.value = planId;
          const valueEl = frequencyDropdown.querySelector(".dropdown__value");
          if (valueEl) valueEl.textContent = opt.textContent.trim();
          options.forEach((o) => {
            o.classList.toggle("dropdown__option--selected", o === opt);
            o.setAttribute("aria-selected", o === opt ? "true" : "false");
          });
        };
        const refreshDropdownOptions = (plans, selectedId) => {
          if (!frequencyDropdown) return;
          const menu = frequencyDropdown.querySelector(".dropdown__menu");
          if (!menu) return;
          const applicable = new Set(plans.map((p) => String(p.id)));
          const options = Array.from(
            menu.querySelectorAll(".dropdown__option")
          );
          options.forEach((o) => {
            o.hidden = !applicable.has(o.dataset.value || "");
          });
          plans.forEach((p) => {
            const li = options.find((o) => o.dataset.value === String(p.id));
            if (li) menu.appendChild(li);
          });
          setDropdownSelection(selectedId);
        };
        const parseSellingPlanDiscountMap = (raw) => {
          const map = /* @__PURE__ */ new Map();
          const text = String(raw || "").trim();
          if (!text) return map;
          text.split(",").forEach((segment) => {
            const parts = segment.trim().split("/").map((part) => part.trim());
            if (parts.length < 3) return;
            const [planId, initialKey, recurringKey] = parts;
            if (!planId) return;
            map.set(String(planId), { initialKey, recurringKey });
          });
          return map;
        };
        const planDiscountMap = parseSellingPlanDiscountMap(
          section.dataset.sellingPlanDiscountMap || ""
        );
        const showFrequencySelector = section.dataset.showFrequencySelector !== "false";
        const resolveMappedPlanPricing = (plan, variantPlans) => {
          const mapping = planDiscountMap.get(String(plan.id));
          const discounts = variantPlans?.discounts;
          if (!mapping?.initialKey || !discounts || typeof discounts !== "object") {
            return { price: plan.price, discount: plan.discount };
          }
          const pct = Number(discounts[mapping.initialKey]) || 0;
          if (pct <= 0) {
            return { price: plan.price, discount: plan.discount };
          }
          const originalPrice = Number(variantPlans.price) || 0;
          const compareAt = Number(variantPlans.compareAt) || 0;
          const base = compareAt > 0 ? compareAt : originalPrice;
          const calculated = Math.round(base * (1 - pct / 100));
          const price = compareAt > originalPrice ? Math.min(calculated, originalPrice) : calculated;
          return { price, discount: pct };
        };
        const applyPlanToButton = (plan) => {
          if (!submitBtn) return;
          const variantPlans = getVariantPlans(planMap, currentVariantId());
          const resolved = resolveMappedPlanPricing(plan, variantPlans);
          submitBtn.setAttribute("data-subscribe-discount", String(resolved.discount));
          submitBtn.setAttribute("data-subscribe-price", String(resolved.price));
          if (!managePrice || !isSubscribe()) return;
          if (btnPriceEl)
            btnPriceEl.textContent = formatMoney(resolved.price);
          if (btnBadge) {
            if (resolved.discount > 0) {
              btnBadge.textContent = resolved.discount + "% off";
              btnBadge.removeAttribute("hidden");
            } else {
              btnBadge.textContent = "";
              btnBadge.setAttribute("hidden", "");
            }
          }
        };
        const forceOnce = () => {
          const onceBtn = purchaseToggle == null ? void 0 : purchaseToggle.querySelector('[data-toggle="once"]');
          if (onceBtn && (submitBtn == null ? void 0 : submitBtn.classList.contains(subscribeClass)))
            onceBtn.click();
        };
        const sync = (variantId) => {
          const variantPlans = getVariantPlans(planMap, variantId);
          if (!hasPlans(variantPlans)) {
            log("variant has no plans \u2192 hide subscription UI", variantId);
            if (purchaseToggle) purchaseToggle.hidden = true;
            if (frequencyWrap) frequencyWrap.hidden = true;
            forceOnce();
            selectedPlanId = "";
            sellingPlanInput.dataset.sellingPlanId = "";
            sellingPlanInput.value = "";
            return;
          }
          if (purchaseToggle) purchaseToggle.hidden = false;
          const plans = sortPlansByFrequency(variantPlans.plans);
          const plan = findPlanById(plans, selectedPlanId) || preferredPlan(plans);
          selectedPlanId = String(plan.id);
          log("variant plans", { variantId, selectedPlanId, count: plans.length });
          refreshDropdownOptions(plans, selectedPlanId);
          if (frequencyWrap)
            frequencyWrap.hidden = !(showFrequencySelector && plans.length > 1 && isSubscribe());
          sellingPlanInput.dataset.sellingPlanId = selectedPlanId;
          sellingPlanInput.value = isSubscribe() ? selectedPlanId : "";
          applyPlanToButton(plan);
        };
        section.addEventListener("variant:change", (e) => {
          const detail = e.detail;
          sync((detail == null ? void 0 : detail.variantId) || currentVariantId());
        });
        section.addEventListener("dropdown:change", (e) => {
          var _a;
          if (!frequencyDropdown) return;
          const target = e.target;
          if (!frequencyDropdown.contains(target)) return;
          const id = ((_a = e.detail) == null ? void 0 : _a.value) || "";
          selectedPlanId = id;
          sellingPlanInput.dataset.sellingPlanId = id;
          if (isSubscribe()) sellingPlanInput.value = id;
          const variantPlans = getVariantPlans(planMap, currentVariantId());
          const plan = findPlanById((variantPlans == null ? void 0 : variantPlans.plans) || [], id);
          if (plan) applyPlanToButton(plan);
          log("frequency change", { id });
        });
        purchaseToggle == null ? void 0 : purchaseToggle.addEventListener(
          "click",
          () => setTimeout(() => {
            const variantPlans = getVariantPlans(planMap, currentVariantId());
            const count = (variantPlans == null ? void 0 : variantPlans.plans.length) || 0;
            if (frequencyWrap)
              frequencyWrap.hidden = !(showFrequencySelector && count > 1 && isSubscribe());
          }, 0)
        );
        sync(currentVariantId());
      };
      return {
        formatMoney,
        attrInt,
        getDiscountedPrice,
        makeAnimateBtnContent,
        makeAnimateImageTransition,
        initSubscribeToggle,
        initQuantityChange,
        initVariantPlanSync
      };
    })();
  })();
})();
